var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { createContext } from "react";
import { createCacheKey, wrapCache } from "./cache";
var cache = wrapCache(new Map());
var defaultConfig = {
    cache: cache,
    cacheKey: createCacheKey,
};
export var RequestContext = createContext(defaultConfig);
RequestContext.displayName = "RequestHookConfig";
export var RequestProvider = function (props) {
    var children = props.children, instance = props.instance, cache = props.cache, cacheKey = props.cacheKey, cacheFilter = props.cacheFilter, customCreateReqError = props.customCreateReqError, rest = __rest(props, ["children", "instance", "cache", "cacheKey", "cacheFilter", "customCreateReqError"]);
    return (React.createElement(RequestContext.Provider, __assign({ value: {
            instance: instance,
            cache: cache,
            cacheKey: cacheKey,
            cacheFilter: cacheFilter,
            customCreateReqError: customCreateReqError,
        } }, rest), children));
};
RequestProvider.defaultProps = defaultConfig;
export var RequestConsumer = RequestContext.Consumer;
